<template>
  <div class="row service-bg">
    <div class="col">
      <div class="service-title">
        <span>Servicio:</span>
      </div>
      <div class="service-content">
        <span>{{ item.service.name }}</span>
      </div>
    </div>
    <div class="col">
      <div class="service-title">
        <span>Frecuencia:</span>
      </div>
      <div class="service-content">
        <span>
          {{ item.frequency }}
        </span>
      </div>
    </div>
    <div class="col">
      <div class="service-title">
        <span>Costo:</span>
      </div>
      <div class="service-content">
        <span>{{ item.cost | price }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      require: true,
      default: () => ({
        service: {
          name: '',
        },
        frequency: 0,
        cost: 0,
      }),
    },
  },
};
</script>

<style scoped>
.service-bg {
  background: #f7f7f7;
  border-radius: 5px;
  margin: 10px 0 0 0;
  padding: 15px;
}
.service-title {
  color: #727272;
  font: normal normal normal 14px/28px Lato;
  font-weight: 700;
}
.service-content {
  color: #11291b;
  font: normal normal normal 16px/20px Lato;
}
</style>
